import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { PureComponent } from 'react';

import { channelAttributes } from 'utils/channels';

import styles from './index.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Is conversation closed */
  isClosed?: boolean;
  /** Does the conversation have a follow up? */
  hasFollowUp?: boolean;
  /** The conversation channel */
  channel:
    | 'adachat'
    | 'digitalgeniuschat'
    | 'kindlychat'
    | 'genericapimessaging'
    | 'trustpilotreviews'
    | 'yotporeviews'
    | 'pstnphone'
    | 'email'
    | 'widgetchat'
    | 'messenger'
    | 'facebookmessenger'
    | 'whatsapp'
    | 'sms'
    | 'callback'
    | 'contactform'
    | 'voicemail'
    | 'twitter';
};

export class TimelineIcon extends PureComponent<PropsT> {
  render() {
    const { className, isClosed, channel, hasFollowUp, ...otherProps } =
      this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
        [styles.rootActive]: !isClosed,
        [styles.rootFollowUp]: hasFollowUp,
      },
      className,
    );

    const channelIcon = channel
      ? channelAttributes[convertChannelCasing(channel, 'snake')]?.icon
      : null;

    return (
      <div>
        <div {...otherProps} className={rootClass}>
          <div className={styles.inner}>
            <Icon name={channelIcon} size={16} />
          </div>
        </div>
      </div>
    );
  }
}
